export default __webpack_public_path__ + "static/media/mixkit-unlock-game-notification-253.3e2b8a36.wav";